let SkeletonAnimation = /*#__PURE__*/function (SkeletonAnimation) {
  SkeletonAnimation["PULSE"] = "pulse";
  SkeletonAnimation["WAVE"] = "wave";
  return SkeletonAnimation;
}({});

export { SkeletonAnimation };
//# sourceMappingURL=animation.js.map
